export const managerPrices = {
  page: {
    title: "Tarifs de la plateforme",
    subtitle: "Liste des tarifs des forfaits de la plateforme",
  },
  table: {
    name: "Nom",
    type: "Type",
    price: "Prix",
    created: "Créé le",
    edit: "Modifier le prix",
  },
  form: {
    title: "Mettre à jour le prix",
    planName: "Nom du forfait",
    planType: "Type de forfait",
    annual: "Annuel",
    monthly: "Mensuel",
    cancel: "Annuler",
    save: "Enregistrer",
  },
  toast: {
    saved: "Enregistré avec succès",
    error: "Erreur de requête",
  },
};
